<template>
  <el-dialog :title="receipt ? '选择收款核销' : '选择付款核销'" :visible.sync="inner" width="860px" append-to-body :close-on-click-modal="false" @open="load">
    <el-table :data="list" border height="360" @selection-change="rows => selected = rows">
      <el-table-column type="selection" width="46" />
      <el-table-column prop="writeOffType" label="类型" width="100">
        <template slot-scope="scope">{{ scope.row.writeOffType === 'invoice' ? '发票' : scope.row.writeOffType === 'opening' ? (receipt ? '期初应收' : '期初应付') : (receipt ? '应收' : '应付') }}</template>
      </el-table-column>
      <el-table-column prop="billCode" label="单号" width="160" />
      <el-table-column prop="materialName" label="物料" min-width="140" />
      <el-table-column prop="totalAmount" label="金额" width="110" align="right" />
      <el-table-column prop="remainAmount" label="可核销" width="110" align="right" />
    </el-table>
    <span slot="footer">
      <el-button @click="inner = false">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import request from '../api/request'
export default {
  props: { visible: Boolean, partnerId: String, excludeId: { type: String, default: '' }, receipt: { type: Boolean, default: true } },
  data() { return { list: [], selected: [] } },
  computed: {
    inner: { get() { return this.visible }, set(v) { this.$emit('update:visible', v) } }
  },
  methods: {
    load() {
      if (!this.partnerId) { this.list = []; return }
      request.get('/finance/cash/pendingWriteOff', {
        params: { kind: this.receipt ? 'receipt' : 'payment', partnerId: this.partnerId, excludeId: this.excludeId || '' }
      }).then(res => { this.list = res.data || [] }).catch(() => {})
    },
    confirm() {
      if (!this.selected.length) { this.$message.warning('请选择核销对象'); return }
      this.$emit('select', this.selected)
      this.inner = false
    }
  }
}
</script>
